import { playTransitionCubicEaseInOut, SlashTiming } from 'app/ui-components/design-tokens';
import styled, { css } from 'styled-components';
import { device } from '../../ui-components/breakpoints';
import { ContainerBase } from '../../ui-components/PlayContainer/PlayContainer.styles';
import { VisuallyHidden } from '../../ui-components/utils.styles';

export const ReactBase = styled.div`
    height: 100%;

    ${(props) =>
        props.videoModalOpen &&
        css`
            transition: opacity ${SlashTiming}ms ${playTransitionCubicEaseInOut};
            opacity: 0;

            @media screen and (prefers-reduced-motion: reduce) {
                transition: none;
            }
        `}
`;

export const MainContent = styled.main`
    flex: 1 0 auto;
    margin-bottom: 20px;

    &:focus {
        outline: none;
    }

    @media ${device.GteMedium} {
        margin-bottom: 35px;
    }

    ${ContainerBase}
`;

export const A11yAnnouncer = styled.div`
    ${VisuallyHidden}
`;
